export class RouterUtil {

  public static routeWithoutParam(route: string) {
    const routes = route.split('/');
    return routes.slice(0, routes.length - 1).join('/');
  }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/router.util.ts